import * as promisePolyfill from "es6-promise";
promisePolyfill.polyfill();

import { FilterBarDock } from "./filter-bar-dock";
import { Menu } from "./menu";
import { Footer } from "./footer";
import { CalendarWidget } from './widgets/calendar-widget';
import { PressArchive } from './pages/press-archive';
import { SshgGallery } from "./gallery/sshg-gallery";
import { ModalHost } from "./libs/modal-host";
import { Magazine } from "./pages/magazine";
import { Home } from "./pages/home";
import { ActiveHome } from "./pages/active-home";
import { ActiveMagazine } from "./pages/active-magazine";
import { DigitalFestival } from "./pages/digital-festival";
import { BuergerinnenBuehneHome } from "./pages/buergerinnenbuehne-home";
import { BuergerinnenBuehneMagazine } from "./pages/buergerinnenbuehne-magazine";
import { TeamOverview } from "./pages/team-overview";
import { Columns } from "./pages/columns";
import { SeasonPlay } from "./pages/season-play"
import { ImageOverlayHelper } from "./libs/image-overlay-helper";
import { ProductionDetails } from "./pages/production-details";
import { MomentLocaleFix } from "./fixes/moment-locale-fix";
import { RecommenderRenderer } from "./renderer/recommender-renderer";
import { DocumentManagment } from "./pages/documentManagement";
import { Magazine2 } from "./pages/magazine2";
import { ETCRenaissance } from "./pages/etc-renaissance";
import { Magazine3 } from "./pages/magazine3";
import { WeMagazine } from "./pages/we-magazine";
import { Recommenderbar } from "./recommenderbar";

declare var Hyphenator: any;
declare var THOR: any


class Main {

	private static lastScrollY = 0;
	private static lastScrollX = 0;

	static init() {
		document.addEventListener('DOMContentLoaded', Main.onDocumentLoaded, false);
	}

	private static onDocumentLoaded() {

		MomentLocaleFix.init();

		window.addEventListener("scroll", Main.onScroll);
		document.addEventListener("keyup", event => Main.onKeyup(event));

		var main = document.getElementsByTagName("main")[0];
		var body = document.getElementsByTagName("body")[0];

		if (body != null && main != null) {
			if (main.classList.contains("whitePage")) {
				body.style.backgroundColor = "white";
			}
		}

		var isIndex = document.getElementById('p_home') != null;
		if(isIndex) {
			THOR.Main.logEvent({'type': 'INDEX'}, '30', function(){});
		}

		SshgGallery.init();
		ImageOverlayHelper.init();
	}

	private static onScroll() {
		// if(!ModalHost.shouldScroll()) {
		// 	console.log("N");
		// 	window.scrollTo( Main.lastScrollX, Main.lastScrollY );
		// }

		// Main.lastScrollX = window.scrollX;
		// Main.lastScrollY = window.scrollY;

	}

	private static onKeyup(event: KeyboardEvent) {
		if (event.keyCode == 27) {
			ModalHost.tryClose();
		}
	}
}

Main.init();
Menu.init();
FilterBarDock.init();
Footer.init();
Recommenderbar.init();

export { CalendarWidget };
export { PressArchive };
export { Magazine };
export { Home };
export { ActiveHome };
export { ActiveMagazine };
export { DigitalFestival};
export { BuergerinnenBuehneHome };
export { BuergerinnenBuehneMagazine };
export { TeamOverview };
export { Columns };
export { SeasonPlay };
export { ProductionDetails };
export { RecommenderRenderer };
export { DocumentManagment };
export { Magazine2 };
export { ETCRenaissance };
export { Magazine3 };
export { WeMagazine };
export { SshgGallery };
